var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3699 9.51904H17.6199",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38013 9.51904L7.13013 10.269L9.38013 8.01904",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3699 16.519H17.6199",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38013 16.519L7.13013 17.269L9.38013 15.019",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00024 22.6392L15.0002 22.6392C20.0002 22.6392 22.0002 20.6392 22.0002 15.6392L22.0002 9.63916C22.0002 4.63916 20.0002 2.63916 15.0002 2.63916L9.00024 2.63916C4.00024 2.63916 2.00024 4.63916 2.00024 9.63916L2.00024 15.6392C2.00024 20.6392 4.00024 22.6392 9.00024 22.6392Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskSquare);
export default __webpack_public_path__ + "static/media/task-square.189502d9807130dc7ea9542fd42b5589.svg";
export { ForwardRef as ReactComponent };